const clickModifiers={1:'Cap',2:'Frame',5:'Diamond-Cap',6:'Diamond-Frame'};
const clickModifierToModel={1:0,2:1,5:0,6:1};
const vampTeethTop=[6,11];
const caratMaterials=[0,1,2];
const COLOR_PRICE_TABLE={1:215,2:398.50,3:571.50,4:748,5:911.25,6:988.50,7:1300.25,8:1402,9:1624.50,10:1805,11:1856.25,12:1962,13:2148.25,14:2387,15:2478.75,16:2616};

let grillConfiguration={material:0,carat:14,chromePlating:'none',bridge:false,teeth:{
5:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
6:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
7:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
8:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
9:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
10:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
11:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
12:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
21:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
22:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
23:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
24:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
25:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
26:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
27:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
28:{selected:false,model:0,letter:false,icon:false,diamond:false,colorCode:null,material:null,carat:null,plating:null},
}};

let configuratorMode='material';
let activeColorCode=null;
let currentClickModifier=1;
let currentCancellationToken;
let currentSelectedTooth;

window.addEventListener('load',()=>{
    const shouldOpenCart=window.sessionStorage.getItem('shouldOpenCart')==='true';
    if(shouldOpenCart){setTimeout(()=>{document.getElementById('cart-icon-bubble').click();},1000);window.sessionStorage.removeItem('shouldOpenCart');}
});

function checkToggleDiamondSettings(){
    const diamondFieldset=document.getElementById('product-configurator__diamonds');
    if(grillConfiguration.material===3||configuratorMode==='color'){diamondFieldset.setAttribute('disabled','disabled');}
    else{diamondFieldset.removeAttribute('disabled');}
}

function checkToggleCTA(){
    const cartButton=document.getElementById('product-configurator__cartbutton');
    const buyButton=document.getElementById('product-configurator__buybutton');
    const hasSelection=Object.values(grillConfiguration.teeth).some(t=>t.selected);
    if(!hasSelection){cartButton.setAttribute('disabled','disabled');buyButton.setAttribute('disabled','disabled');}
    else{cartButton.removeAttribute('disabled');buyButton.removeAttribute('disabled');}
    updateClearButtonVisibility();
}

function clearAllSelections(){
    for(const toothId in grillConfiguration.teeth){
        grillConfiguration.teeth[toothId].selected=false;
        grillConfiguration.teeth[toothId].model=0;
        grillConfiguration.teeth[toothId].diamond=false;
        grillConfiguration.teeth[toothId].colorCode=null;
        grillConfiguration.teeth[toothId].material=null;
        grillConfiguration.teeth[toothId].carat=null;
        grillConfiguration.teeth[toothId].plating=null;
        grillConfiguration.teeth[toothId].letter=false;
        grillConfiguration.teeth[toothId].icon=false;
        updateToothDisplay(toothId);
    }
    grillConfiguration.bridge=false;
    const bridgeFalse=document.getElementById('product-configurator__bridge-false');
    if(bridgeFalse)bridgeFalse.checked=true;
    getAndUpdatePrice();
    checkToggleCTA();
    updateClearButtonVisibility();
}

function updateClearButtonVisibility(){
    const clearBtn=document.getElementById('product-configurator__clear-btn');
    if(!clearBtn)return;
    const hasSelection=Object.values(grillConfiguration.teeth).some(t=>t.selected);
    clearBtn.style.display=hasSelection?'block':'none';
}

function checkToggleCaratSettings(){
    const caratSelector=document.getElementById('product-configurator__carat');
    if(caratMaterials.includes(grillConfiguration.material)){caratSelector.removeAttribute('disabled');}
    else{caratSelector.setAttribute('disabled','disabled');}
}

function checkToggleChromePlatingSettings(){
    const platingFieldset=document.getElementById('product-configurator__chrom-plating');
    if(!platingFieldset)return;
    if(grillConfiguration.material===3){platingFieldset.removeAttribute('disabled');}
    else{
        platingFieldset.setAttribute('disabled','disabled');
        if(grillConfiguration.chromePlating!=='none'){
            grillConfiguration.chromePlating='none';
            const noneRadio=document.getElementById('product-configurator__chrom-plating-none');
            if(noneRadio)noneRadio.checked=true;
        }
    }
}

function checkToggleColorSettings(){
    const colorFieldset=document.getElementById('product-configurator__color');
    if(!colorFieldset)return;
    if(grillConfiguration.chromePlating!=='none'){colorFieldset.setAttribute('disabled','disabled');resetColorMode();}
    else{colorFieldset.removeAttribute('disabled');}
}

function checkToggleModifierSettings(){
    const frameInput=document.getElementById('product-configurator__modifier-frame');
    const capInput=document.getElementById('product-configurator__modifier-cap');
    const vampFieldset=document.getElementById('product-configurator__vamp');
    if(!frameInput)return;
    if(configuratorMode==='color'){
        frameInput.setAttribute('disabled','disabled');
        if(capInput&&!capInput.checked){capInput.checked=true;currentClickModifier=1;}
        if(vampFieldset){
            vampFieldset.setAttribute('disabled','disabled');
            const vampFalse=document.getElementById('product-configurator__vamp-false');
            if(vampFalse&&!vampFalse.checked){
                vampFalse.checked=true;
                for(const toothId of vampTeethTop){grillConfiguration.teeth[toothId].model=0;updateToothDisplay(toothId);}
            }
        }
    } else {
        frameInput.removeAttribute('disabled');
        if(vampFieldset)vampFieldset.removeAttribute('disabled');
    }
}

function resetColorMode(){
    configuratorMode='material';activeColorCode=null;
    const noneRadio=document.getElementById('color-none');
    if(noneRadio)noneRadio.checked=true;
}

function getDisplayMaterial(){
    if(grillConfiguration.material===3&&grillConfiguration.chromePlating!=='none'){
        const p={'rosegold':1,'weissgold':2,'gelbgold':0};
        return p[grillConfiguration.chromePlating]??3;
    }
    return grillConfiguration.material;
}

function updateToothDisplay(toothNr){
    document.querySelectorAll('[id^="'+toothNr+'_"]').forEach(el=>{el.classList.add('hide');});
    document.querySelectorAll('.product-configurator__color-overlay[data-tooth-id="'+toothNr+'"]').forEach(el=>{el.classList.add('hide');});
    const tooth=grillConfiguration.teeth[toothNr];
    if(!tooth.selected)return;
    if(tooth.colorCode){
        const colorImg=document.getElementById('color-'+toothNr+'-'+tooth.colorCode);
        if(colorImg){forceEagerLoading(colorImg);colorImg.classList.remove('hide');}
    } else {
        const toothMaterial=(tooth.material!==null&&tooth.material!==undefined)?tooth.material:grillConfiguration.material;
        const toothPlating=tooth.plating??'none';
        let displayMaterial;
        if(toothMaterial===3&&toothPlating!=='none'){
            const p={'rosegold':1,'weissgold':2,'gelbgold':0};
            displayMaterial=p[toothPlating]??3;
        } else {displayMaterial=toothMaterial;}
        const pictureNode=document.getElementById(toothNr+'_'+displayMaterial+'_'+tooth.model+'_'+(tooth.diamond?1:0));
        forceEagerLoading(pictureNode);
        pictureNode?.classList.remove('hide');
    }
}

function clickTooth(toothNr){
    document.querySelectorAll('.tooth-pulse').forEach(el=>el.classList.remove('tooth-pulse'));
    document.getElementById('product-configurator__pointer').classList.add('hide');
    const tooth=grillConfiguration.teeth[toothNr];
    if(configuratorMode==='color'&&activeColorCode){
        if(tooth.colorCode===activeColorCode&&tooth.selected){tooth.colorCode=null;tooth.selected=false;}
        else{tooth.diamond=false;tooth.letter=false;tooth.icon=false;tooth.model=0;tooth.colorCode=activeColorCode;tooth.selected=true;}
        updateToothDisplay(toothNr);getAndUpdatePrice();checkToggleCTA();return;
    }
    tooth.colorCode=null;
    tooth.material=grillConfiguration.material;
    tooth.carat=grillConfiguration.carat;
    tooth.plating=(grillConfiguration.material===3)?grillConfiguration.chromePlating:'none';
    const clickModificator=clickModifiers[currentClickModifier];
    switch(clickModificator){
        case'Icon':currentSelectedTooth=toothNr;return;
        case'Letter':
            currentSelectedTooth=toothNr;
            document.getElementById('product-configurator__modal').classList.remove('hide');
            document.getElementById('product-configurator__modal-window-letter').classList.remove('hide');
            document.body.classList.add('noscroll');return;
        case'Select':tooth.selected=!tooth.selected;break;
        case'Cap':
            if(tooth.model!==0||tooth.diamond){tooth.model=0;tooth.diamond=false;tooth.selected=true;tooth.letter=false;tooth.icon=false;}
            else{tooth.selected=!tooth.selected;}break;
        case'Frame':
            if(tooth.model!==1){tooth.model=1;tooth.selected=true;tooth.letter=false;tooth.icon=false;}
            else{tooth.selected=!tooth.selected;}break;
        case'Diamond-Cap':
            if(tooth.diamond&&tooth.model===0){tooth.selected=!tooth.selected;}
            else{tooth.model=0;tooth.diamond=true;tooth.selected=true;}break;
        case'Diamond-Frame':
            if(tooth.diamond&&tooth.model===1){tooth.selected=!tooth.selected;}
            else{tooth.model=1;tooth.diamond=true;tooth.selected=true;}break;
    }
    updateToothDisplay(toothNr);checkBridgeConditions();getAndUpdatePrice();checkToggleCTA();checkToggleVamps();
}

function checkBridgeConditions(){
    if(grillConfiguration.teeth['6'].model===2&&grillConfiguration.teeth['11'].model===2
        &&grillConfiguration.teeth['7'].selected===false&&grillConfiguration.teeth['8'].selected===false
        &&grillConfiguration.teeth['9'].selected===false&&grillConfiguration.teeth['10'].selected===false){
        document.getElementById('product-configurator__bridge').removeAttribute('disabled');
    } else {
        if(grillConfiguration.bridge===true){document.getElementById('product-configurator__bridge-false').checked=true;grillConfiguration.bridge=false;}
        document.getElementById('product-configurator__bridge').setAttribute('disabled','disabled');
    }
}

function checkToggleVamps(){
    let hasVamps=true;
    for(const toothId of vampTeethTop){if(grillConfiguration.teeth[toothId].model!==2){hasVamps=false;break;}}
    if(hasVamps){document.getElementById('product-configurator__vamp-true').checked=true;}
    else if(document.getElementById('product-configurator__vamp-true').checked){
        document.getElementById('product-configurator__vamp-false').checked=true;
        for(const toothId of vampTeethTop){grillConfiguration.teeth[toothId].model=clickModifierToModel[currentClickModifier];updateToothDisplay(toothId);}
    }
}

function getAndUpdatePrice(){
    document.getElementById('product-configurator__price-number').innerText='';
    document.getElementById('product-configurator__price-number').classList.add('loading');
    currentCancellationToken=Symbol('price');
    getPrice(currentCancellationToken).then(function([price,token]){
        updatePrice(price,token);
        document.getElementById('product-configurator__price-number').classList.remove('loading');
    });
}

function updatePrice(price,cancellationToken){
    if(currentCancellationToken!==cancellationToken)return;
    document.getElementById('product-configurator__price-number').innerText=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(price/100);
}

function getSelectedTeeth(){
    return Object.entries(grillConfiguration.teeth).filter(tooth=>tooth[1].selected).reduce((teeth,tooth)=>{teeth[tooth[0]]=tooth[1];return teeth;},{});
}
function getMaterialTeeth(){
    return Object.entries(grillConfiguration.teeth).filter(([,tooth])=>tooth.selected&&!tooth.colorCode).reduce((teeth,tooth)=>{teeth[tooth[0]]=tooth[1];return teeth;},{});
}
function getColorTeeth(){
    return Object.entries(grillConfiguration.teeth).filter(([,tooth])=>tooth.selected&&tooth.colorCode).reduce((teeth,tooth)=>{teeth[tooth[0]]=tooth[1];return teeth;},{});
}

async function getPrice(cancellationToken){
    let materialPrice=0,colorPrice=0,diamondsByModel={};
    const materialTeeth=getMaterialTeeth(),colorTeeth=getColorTeeth();
    const discountGroups={};
    for(const toothNr in materialTeeth){
        const tooth=materialTeeth[toothNr];
        const toothMaterial=tooth.material??grillConfiguration.material;
        const toothCarat=tooth.carat??grillConfiguration.carat;
        const toothPlating=tooth.plating??((toothMaterial===3)?grillConfiguration.chromePlating:'none');
        const toothPrice=await getVariantAttribute(toothNr,toothMaterial,tooth.model,toothCarat,'price',false,toothPlating);
        if(toothPrice===undefined)throw new Error('Tooth price not found: '+toothNr);
        const goldId=materialToGold[toothMaterial];
        const groupKey=goldId===0?Material[toothMaterial].toLowerCase():toothCarat.toString();
        if(!discountGroups[groupKey])discountGroups[groupKey]={count:0,subtotal:0};
        discountGroups[groupKey].count++;
        discountGroups[groupKey].subtotal+=toothPrice;
        if(tooth.diamond)diamondsByModel[tooth.model]=(diamondsByModel[tooth.model]||0)+1;
    }
    if(grillConfiguration.bridge){
        const bridgePrice=await getVariantAttribute(0,grillConfiguration.material,0,grillConfiguration.carat,'price',true,grillConfiguration.chromePlating);
        if(bridgePrice===undefined)throw new Error('Bridge price not found');
        const goldId=materialToGold[grillConfiguration.material];
        const bridgeGroupKey=goldId===0?Material[grillConfiguration.material].toLowerCase():grillConfiguration.carat.toString();
        if(!discountGroups[bridgeGroupKey])discountGroups[bridgeGroupKey]={count:0,subtotal:0};
        discountGroups[bridgeGroupKey].count++;
        discountGroups[bridgeGroupKey].subtotal+=bridgePrice;
    }
    for(const[groupKey,group]of Object.entries(discountGroups)){
        const count=Math.min(group.count,16);
        const discount=discountMap[groupKey]?.[count]??0;
        materialPrice+=reduceByPercent(group.subtotal,discount);
    }
    const diamondPrices=await getDiamondAttributeByModel('price');
    for(const[model,quantity]of Object.entries(diamondsByModel))materialPrice+=diamondPrices[model]*quantity;
    const colorCount=Object.keys(colorTeeth).length;
    if(colorCount>0)colorPrice=(COLOR_PRICE_TABLE[Math.min(colorCount,16)]||0)*100;
    return[materialPrice+colorPrice,cancellationToken];
}

function getDiscountInfo(){
    const materialTeeth=getMaterialTeeth();
    const countSelectedTeeth=Object.keys(materialTeeth).length;
    const groupCounts={};
    for(const tooth of Object.values(materialTeeth)){
        const toothMaterial=tooth.material??grillConfiguration.material;
        const toothCarat=tooth.carat??grillConfiguration.carat;
        const goldId=materialToGold[toothMaterial];
        const key=goldId===0?Material[toothMaterial].toLowerCase():toothCarat.toString();
        groupCounts[key]=(groupCounts[key]||0)+1;
    }
    const materialName=Object.entries(groupCounts).sort((a,b)=>b[1]-a[1])[0]?.[0]??'chrom';
    return{countSelectedTeeth,materialName};
}

function reducePriceDiscount(price){
    const{countSelectedTeeth,materialName}=getDiscountInfo();
    if(countSelectedTeeth===0)return 0;
    const discount=discountMap[materialName][countSelectedTeeth];
    return reduceByPercent(price,discount);
}

function reduceByPercent(price,percent){return(price*100-Math.round(price*percent))/100;}

async function ctaClick(buttonType){
    const allSelected=getSelectedTeeth();
    if(Object.keys(allSelected).length===0)return;
    document.getElementById('product-configurator__cartbutton').setAttribute('disabled','disabled');
    document.getElementById('product-configurator__buybutton').setAttribute('disabled','disabled');
    let formData={items:[]};
    let diamondsByModel={};
    const configId=Date.now();
    const materialTeeth=getMaterialTeeth(),colorTeeth=getColorTeeth();
    for(const toothNr in materialTeeth){
        const tooth=materialTeeth[toothNr];
        const toothMaterial=tooth.material??grillConfiguration.material;
        const toothCarat=tooth.carat??grillConfiguration.carat;
        const toothPlating=tooth.plating??((toothMaterial===3)?grillConfiguration.chromePlating:'none');
        const toothId=await getVariantAttribute(toothNr,toothMaterial,tooth.model,toothCarat,'id',false,toothPlating);
        if(toothId===undefined)throw new Error('Tooth variant not found: '+toothNr);
        let properties={'Konfigurations ID':configId};
        if(tooth.letter!==false)properties['letter']=tooth.letter;
        if(tooth.icon!==false)properties['icon']=tooth.icon;
        if(toothPlating!=='none'){
            const pl={'rosegold':'Rosegold Vergoldung','weissgold':'Weißgold Vergoldung','gelbgold':'Gelbgold Vergoldung'};
            properties['Chrom Veredelung']=pl[toothPlating];
        }
        formData.items.push({id:toothId,quantity:1,properties});
        if(tooth.diamond)diamondsByModel[tooth.model]=(diamondsByModel[tooth.model]||0)+1;
    }
    for(const toothNr in colorTeeth){
        const tooth=colorTeeth[toothNr];
        const toothId=await getVariantAttribute(toothNr,3,tooth.model,grillConfiguration.carat,'id',false,'none');
        if(toothId===undefined){console.warn('Color tooth variant not found: '+toothNr);continue;}
        formData.items.push({id:toothId,quantity:1,properties:{'Konfigurations ID':configId,'Farbe':tooth.colorCode}});
    }
    const diamondIds=await getDiamondAttributeByModel('id');
    for(const[model,quantity]of Object.entries(diamondsByModel)){
        formData.items.push({id:diamondIds[model],quantity:quantity,properties:{'Konfigurations ID':configId}});
    }
    if(grillConfiguration.bridge){
        const bridgeId=await getVariantAttribute(0,grillConfiguration.material,0,grillConfiguration.carat,'id',true,grillConfiguration.chromePlating);
        if(bridgeId===undefined)throw new Error('Bridge variant not found');
        formData.items.push({id:bridgeId,quantity:1,properties:{'Konfigurations ID':configId}});
    }
    await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(formData)}).catch(error=>{console.error('Cart error:',error);checkToggleCTA();throw error;});
    const{countSelectedTeeth,materialName}=getDiscountInfo();
    let discountName='';
    if(countSelectedTeeth>1)discountName=materialName+' '+countSelectedTeeth;
    await fetch(window.Shopify.routes.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:discountName})}).catch(error=>{console.error('Discount error:',error);checkToggleCTA();throw error;});
    if(buttonType==='cart'){window.sessionStorage.setItem('shouldOpenCart','true');window.location.reload();}
    if(buttonType==='buy'){window.location=window.location.origin+'/checkout';window.localStorage.removeItem('config-discounts');}
}

document.querySelectorAll('.product-configurator__toothsvg').forEach((element)=>{
    element.addEventListener('click',(event)=>{clickTooth(event.target.dataset.tooth);});
});

document.querySelectorAll('#product-configurator__material input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
        const newMaterial=Number(e.target.value);
        if(newMaterial===3){
            const diamondsActive=document.querySelector('#product-configurator__diamonds-true')?.checked;
            if(diamondsActive){
                for(const toothId in grillConfiguration.teeth){grillConfiguration.teeth[toothId].selected=false;grillConfiguration.teeth[toothId].diamond=false;grillConfiguration.teeth[toothId].colorCode=null;updateToothDisplay(toothId);}
                const diamondsFalse=document.getElementById('product-configurator__diamonds-false');
                if(diamondsFalse)diamondsFalse.checked=true;
                if(currentClickModifier>4)currentClickModifier=currentClickModifier-4;
            }
        }
        if(configuratorMode==='color'){resetColorMode();checkToggleModifierSettings();}
        grillConfiguration.material=newMaterial;
        const teethSvgElement=document.getElementById('product-configurator__teethsvg');
        teethSvgElement.className.baseVal='product-configurator__teethsvg';
        teethSvgElement.classList.add(Material[newMaterial].toLowerCase());
        for(const toothNr in getSelectedTeeth()){
            grillConfiguration.teeth[toothNr].material=newMaterial;
            grillConfiguration.teeth[toothNr].plating=(newMaterial===3)?grillConfiguration.chromePlating:'none';
            updateToothDisplay(toothNr);
        }
        getAndUpdatePrice();checkToggleDiamondSettings();checkToggleCTA();checkToggleCaratSettings();checkToggleChromePlatingSettings();checkToggleColorSettings();
    });
});

document.querySelectorAll('#product-configurator__carat input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
        grillConfiguration.carat=Number(e.target.value);
        for(const toothNr in getSelectedTeeth()){
            grillConfiguration.teeth[toothNr].carat=grillConfiguration.carat;
        }
        getAndUpdatePrice();
    });
});

document.querySelectorAll('#product-configurator__chrom-plating input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
       grillConfiguration.chromePlating=e.target.value;
        for(const toothNr in getSelectedTeeth()){
            if(grillConfiguration.teeth[toothNr].material===3){
                grillConfiguration.teeth[toothNr].plating=e.target.value;
            }
            updateToothDisplay(toothNr);
        }
        getAndUpdatePrice();checkToggleColorSettings();
    });
});

document.querySelectorAll('#product-configurator__color input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
        if(e.target.value==='none'){resetColorMode();checkToggleModifierSettings();checkToggleDiamondSettings();return;}
        configuratorMode='color';activeColorCode=e.target.value;
        if(grillConfiguration.material!==3){
            grillConfiguration.material=3;
            const chromRadio=document.getElementById('product-configurator__material-chrome');
            if(chromRadio){document.querySelectorAll('input[name="product-configurator__material"]').forEach(r=>r.checked=false);chromRadio.checked=true;}
            const teethSvgElement=document.getElementById('product-configurator__teethsvg');
            teethSvgElement.className.baseVal='product-configurator__teethsvg';
            teethSvgElement.classList.add('chrom');
            checkToggleCaratSettings();checkToggleChromePlatingSettings();
        }
        const diamondsActive=document.querySelector('#product-configurator__diamonds-true')?.checked;
        if(diamondsActive){
            const diamondsFalse=document.getElementById('product-configurator__diamonds-false');
            if(diamondsFalse)diamondsFalse.checked=true;
            if(currentClickModifier>4)currentClickModifier=currentClickModifier-4;
        }
        checkToggleModifierSettings();checkToggleDiamondSettings();getAndUpdatePrice();
    });
});

document.querySelectorAll('#product-configurator__modifier input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
        const isDiamond=document.querySelector('#product-configurator__diamonds-true').checked;
        if(isDiamond){currentClickModifier=Number(e.target.value)+4;}
        else{currentClickModifier=Number(e.target.value);}
    });
});

document.querySelectorAll('#product-configurator__vamp input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
        const isEnabled=Boolean(Number(e.target.value));
        for(const toothId of vampTeethTop){
            const tooth=grillConfiguration.teeth[toothId];
            if(isEnabled){tooth.model=2;tooth.selected=true;tooth.colorCode=null;}
            else{tooth.model=clickModifierToModel[currentClickModifier]??0;}
            updateToothDisplay(toothId);
        }
        checkBridgeConditions();getAndUpdatePrice();checkToggleCTA();
    });
});

document.querySelectorAll('#product-configurator__bridge input').forEach((element)=>{
    element.addEventListener('change',(e)=>{grillConfiguration.bridge=Boolean(Number(e.target.value));getAndUpdatePrice();});
});

document.querySelectorAll('#product-configurator__diamonds input').forEach((element)=>{
    element.addEventListener('change',(e)=>{
        const activated=Boolean(Number(e.target.value));
        if(activated){currentClickModifier=currentClickModifier+4;}
        else{currentClickModifier=currentClickModifier-4;document.getElementById('product-configurator__material-chrome').removeAttribute('disabled');}
    });
});

document.getElementById('CartDrawer-Checkout').addEventListener('click',()=>{window.localStorage.removeItem('config-discounts');});